import { ScaffolderInputHeader } from '@internal/plugin-scaffolder-common-field-react';
import React from 'react';

import { Box } from '@material-ui/core';

import {
  KubernetesClusterPicker,
  KubernetesCluster,
} from '../../KubernetesClusterPicker';
import { SELF_MANAGED_CLUSTER_INFO } from '../infoDoc';
import { useStyles } from '../styles';
import { SelfManagedCluster } from '../types';
import { NamespaceInput } from './NamespaceInput';

interface SelfManagedClusterPickerProps {
  formData: SelfManagedCluster;
  onChange: (data: SelfManagedCluster) => void;
  rawErrors: string[];
}

export const SelfManagedClusterPicker = (
  props: SelfManagedClusterPickerProps,
) => {
  const { formData, onChange, rawErrors } = props;
  const classes = useStyles();

  const handleClusterChange = (cluster: KubernetesCluster | string = '') => {
    if (!cluster) {
      onChange({ cluster: null, namespaces: [] });
      return;
    }
    onChange({
      cluster:
        typeof cluster === 'string' ? { name: cluster, id: cluster } : cluster,
      namespaces: ['default'],
    });
  };

  const handleNamespacesChanged = (namespaces: string[]) => {
    onChange({
      ...(formData || {
        cluster: null,
        namespaces: [],
      }),
      namespaces: namespaces,
    });
  };

  return (
    <Box>
      <ScaffolderInputHeader
        title="Cluster"
        description="Select the details for the self-managed cluster."
        infoDoc={SELF_MANAGED_CLUSTER_INFO}
      />
      <Box className={classes.inputContainer}>
        <KubernetesClusterPicker
          onChange={e => handleClusterChange(e)}
          schema={{
            title: 'Cluster Name',
            type: 'object',
          }}
          formData={formData?.cluster || ''}
          uiSchema={{
            'ui:options': {
              onlyUserOwned: true,
            },
          }}
          idSchema={[] as any}
          onBlur={() => {}}
          onFocus={() => {}}
          registry={{} as any}
          disabled={false}
          readonly={false}
          required
          name="Clusters"
          rawErrors={rawErrors}
        />
      </Box>
      <NamespaceInput
        formData={formData?.namespaces || []}
        onChange={handleNamespacesChanged}
        rawErrors={rawErrors}
      />
    </Box>
  );
};
